export type SSEEvent = {
  type: 'progress' | 'complete' | 'error' | 'integrity_warning' | 'audio_script_warning';
  message?: string;
  [key: string]: unknown;
};

// Reads an SSE stream until done, cancelling the reader in all exit paths.
export async function readSSEStream(
  reader: ReadableStreamDefaultReader<Uint8Array>,
  onEvent: (event: SSEEvent) => void
): Promise<void> {
  const decoder = new TextDecoder();
  let buffer = '';
  try {
    // eslint-disable-next-line no-constant-condition
    while (true) {
      const { done, value } = await reader.read();
      if (done) break;

      buffer += decoder.decode(value, { stream: true });
      const lines = buffer.split('\n');
      buffer = lines.pop() ?? '';

      for (const line of lines) {
        if (!line.startsWith('data: ')) continue;
        const raw = line.slice(6).trim();
        if (!raw) continue;
        onEvent(JSON.parse(raw) as SSEEvent);
      }
    }
  } finally {
    void reader.cancel();
  }
}
